// packages import
import { Box, Button, CircularProgress, DialogActions, Typography } from '@mui/material'
import { FC, useContext } from 'react'
// component import
import { Alert } from '../../common/Alert'
import { CustomModal } from '../../common/CustomModal'
/// others
import { useToggleArchiveAccountMutation } from '../../../../generated'
import { CANCEL, NOT_APPLICABLE } from '../../../constants'
import { AppContext } from '../../../context'
import { ActionType } from '../../../context/AppContextReducer'
import { ChartsOfAccountsMenuProps } from '../../../interfaceTypes'
import { useNavigate } from 'react-router-dom'

export const ArchiveAccount: FC<ChartsOfAccountsMenuProps & { type?: string }> = ({
  currentChartOfAccount,
  type = 'Archive'
}) => {
  const { isEdit, dispatch } = useContext(AppContext)
  const navigate = useNavigate()

  const handleClose = () => dispatch({ type: ActionType.SET_IS_EDIT, isEdit: false })
  const { id: accountId, name, accountNo, sortCode, category } = currentChartOfAccount || {}

  const [toggleArchiveAccount, { loading }] = useToggleArchiveAccountMutation({
    onError() {
      Alert.error(`Unable to ${type} account`)
    },

    onCompleted(data) {
      if (data) {
        const { toggleArchiveAccount } = data
        const { account, response } = toggleArchiveAccount || {}

        const { status } = response || {}

        if (status === 200 && account) {
          Alert.success(`Account ${type} successfully`)
          dispatch({ type: ActionType.SET_IS_EDIT, isEdit: false })
          navigate('/accounts/chartered', { replace: true })
        }
      }
    }
  })

  const handleArchiveAccount = () => {
    accountId &&
      toggleArchiveAccount({
        variables: {
          id: accountId
        }
      })
  }

  return (
    <CustomModal title={`${type} Account`} isOpen={isEdit} handleClose={handleClose}>
      <Typography variant="body1">You are about to {type} the following Chart of Account:</Typography>
      <Box mt={1}>
        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Name:{' '}
          </Typography>{' '}
          {name || ''}
        </Typography>

        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Account Number:{' '}
          </Typography>
          {accountNo || NOT_APPLICABLE}
        </Typography>

        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Sort Code:{' '}
          </Typography>
          {sortCode || ''}
        </Typography>

        <Typography variant="body1">
          <Typography component="span" fontWeight={500}>
            Category:{' '}
          </Typography>
          {category || ''}
        </Typography>
      </Box>

      <DialogActions sx={{ padding: '30px 0 0', flexWrap: 'wrap' }}>
        <Button onClick={handleClose} variant="outlined" aria-label={CANCEL}>
          {CANCEL}
        </Button>

        <Button
          disabled={loading}
          onClick={handleArchiveAccount}
          color="primary"
          variant="contained"
          endIcon={loading && <CircularProgress size={20} color="inherit" />}
          aria-label="archive account"
        >
          {type} Account
        </Button>
      </DialogActions>
    </CustomModal>
  )
}
